import { Button } from '@bambi/component-library/src/components/Button/Button';
import { PencilIcon } from '@heroicons/react/24/outline';

import { useAppDispatch } from 'src/app/store/hooks';
import { TagRead } from 'src/common/external/bambi-api/bambiApi';

import { setSelectedTag, setShowTagsModal } from '../../setting.slice';

export function RowActions({ tag }: { tag: TagRead }) {
  const dispatch = useAppDispatch();

  function handleEditTag() {
    dispatch(setSelectedTag({ ...tag }));
    dispatch(setShowTagsModal(true));
  }

  return (
    <Button
      className="group cursor-pointer"
      variant="ghost"
      onClick={() => handleEditTag()}
      ariaLabel="Edit"
      dataTestId={`edit-tag-${tag.id}`}
    >
      <PencilIcon className="w-[24px] group-hover:text-mint" />
    </Button>
  );
}
